module.exports = __webpack_public_path__ + "static/img/bg-id.87ed0562.png";